import React from 'react';
import { useSelector } from 'react-redux';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { useCurrentStateAndParams } from '@wix/tpa-router/react';

import { selectGroupIdBySlug } from 'store/selectors';

import { type TPAComponentProps } from 'wui/types';

import { Column, Layout } from '../Layout';

import { GroupInfoCard } from './GroupInfo';
import { GroupRulesCard } from './GroupRules';
import { GroupActivityCard } from './GroupActivity';
import { GroupDescriptionCard } from './GroupDescription';

export function AboutPage(props: TPAComponentProps) {
  const { isMobile } = useEnvironment();
  const { params } = useCurrentStateAndParams();

  const groupId = useSelector(selectGroupIdBySlug(params.slug));

  if (isMobile) {
    return (
      <Layout {...props}>
        <Column>
          <GroupInfoCard groupId={groupId} sideBorders={false} />
          <GroupDescriptionCard groupId={groupId} sideBorders={false} />
          <GroupActivityCard groupId={groupId} sideBorders={false} />
          <GroupRulesCard groupId={groupId} sideBorders={false} />
        </Column>
      </Layout>
    );
  }

  return (
    <Layout {...props}>
      <Column>
        <GroupActivityCard groupId={groupId} />
        <GroupDescriptionCard
          groupId={groupId}
          data-hook="group-description-card"
        />
        <GroupRulesCard groupId={groupId} />
      </Column>
      <Column>
        <GroupInfoCard groupId={groupId} />
      </Column>
    </Layout>
  );
}

AboutPage.displayName = 'AboutPage';
